// src/hooks/useCompanyProfile.ts
import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { useAuth } from '../contexts/AuthContext';

export const useCompanyProfile = () => {
  const { profile: contextProfile } = useAuth();
  const [localProfile, setLocalProfile] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // If context already has profile, use it
    if (contextProfile?.company_code) {
      setLocalProfile(contextProfile);
      setLoading(false);
      return;
    }

    // Otherwise fetch directly
    const fetchProfile = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        
        if (user) {
          const { data } = await supabase
            .from('profiles')
            .select('id, role, plan, company_code, trial_started_at, trial_ends_at, subscription_status, carrier_limit')
            .eq('id', user.id)
            .single();
          
          setLocalProfile(data);
        }
      } catch (error) {
        console.error('Error fetching profile:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [contextProfile]);

  return { profile: localProfile || contextProfile, loading };
};
